import React from "react";
import { AlertTriangle } from "lucide-react";

/**
 * FCA / s.21 FSMA compliant risk warning banner. Displayed on every page that
 * references investment activity. Wording is deliberately conservative — MAVULA
 * Investment Ltd is not authorised by the Financial Conduct Authority.
 */
export default function RiskWarning({ compact = false }) {
  if (compact) {
    return (
      <div className="mv-card p-4 flex items-start gap-3"
           style={{ background: "rgba(212,60,60,0.06)", borderColor: "rgba(212,60,60,0.20)" }}
           data-testid="risk-warning-compact">
        <AlertTriangle size={16} className="mt-0.5" style={{ color: "#8a2020" }}/>
        <div className="text-[12.5px]" style={{ color: "var(--mv-ink)" }}>
          <strong>Don't invest unless you're prepared to lose all the money you invest.</strong> This is a high-risk investment and you are unlikely to be protected if something goes wrong. MAVULA Investment Ltd is <strong>not authorised or regulated by the Financial Conduct Authority</strong>. Please read <a href="/risk-realities" className="underline mv-green-text">Risk &amp; Realities</a> before proceeding.
        </div>
      </div>
    );
  }
  return (
    <section className="py-8 border-t mv-hairline" style={{ background: "rgba(212,60,60,0.04)" }}
             data-testid="risk-warning">
      <div className="max-w-6xl mx-auto px-4 md:px-8 flex items-start gap-3">
        <AlertTriangle size={22} className="mt-1 shrink-0" style={{ color: "#8a2020" }}/>
        <div>
          <div className="font-display text-[16px]" style={{ color: "#8a2020" }}>Important — this is a high-risk investment</div>
          <p className="mt-1 text-[13.5px]" style={{ color: "var(--mv-ink)" }}>
            <strong>Don't invest unless you're prepared to lose all the money you invest.</strong> MAVULA Investment Ltd (UK Company No. 17368822) is <strong>not authorised or regulated by the Financial Conduct Authority</strong>. Property-based investments offered through MAVULA are unregulated, illiquid and your capital is at risk. Any figures shown are illustrative only, are not a forecast, are subject to project contract, market conditions and local law, and past performance is not a guide to future results. Nothing on this website is a financial promotion to UK retail investors, nor is it financial, tax or legal advice — you must take independent regulated advice before making any decision. Home-ownership plans referenced on this site are developer-set instalment arrangements offered by our local project partners; MAVULA is not an FCA-authorised mortgage lender or credit provider.
            {" "}Read the full <a href="/risk-realities" className="underline mv-green-text">Risk &amp; Realities</a> disclosure.
          </p>
        </div>
      </div>
    </section>
  );
}
